import { indexOf } from 'lodash';

import sortBy from 'lodash/sortBy';

import { DAYS_OF_THE_WEEK, MONTHS } from '../../../constants/cron.constants';

export const INTERVAL_VALUES = [
  {
    id: 'months',
    label: 'Monthly',
  },
  {
    id: 'daysOfWeek',
    label: 'Weekly',
  },
  {
    id: 'hours',
    label: 'Hourly',
  },
  {
    id: 'minutes',
    label: 'Minutely',
  }
]

export const sortWeekdayValues = (weekdayStrings = []) => sortBy(weekdayStrings, weekDayStr => indexOf(DAYS_OF_THE_WEEK, weekDayStr))

export const getNumberValueOfWeekdays = (dayStrings = []) => dayStrings.map(dayStr => indexOf(DAYS_OF_THE_WEEK, dayStr))
export const getNumberValueOfMonths = (monthStrings = []) => monthStrings.map(monthStr => indexOf(MONTHS, monthStr) + 1)

export const generateCronStringFromInputs = ({
  valuePerInterval,
  intervalType,
  dayValues,
  weekdayValues,
  monthValues,
  fromTimeString,
}) => {
  // Currently just support every minute - can be updated in the future
  if (intervalType === 'minutes') {
    return '* * * * *';
  }

  // Not actually hours - hourly by minute
  if (intervalType === 'hours') {
    // Only interval
    return `${valuePerInterval} * * * *`;
  }

  const timeParts = fromTimeString.split(':');
  const minute = timeParts[1]
  const hour = timeParts[0];

  if (intervalType === 'daysOfWeek') {
    const weekdayIndeces = getNumberValueOfWeekdays(weekdayValues).sort((a, b) => a > b);
    const weekdayValsStr = weekdayIndeces?.length === 7 ? '*' : weekdayIndeces.join(',');

    return `${minute} ${hour} * * ${weekdayValsStr}`
  }

  const dayValsStr = dayValues.join(',');

  const monthIndeces = getNumberValueOfMonths(monthValues).sort((a, b) => a > b);
  const monthValsStr = monthIndeces?.length === 12 ? '*' : monthIndeces.join(',');

  return `${minute} ${hour} ${dayValsStr} ${monthValsStr} *`;
}
